module.exports = __webpack_public_path__ + "img/tn.ca1387a5.svg";